"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _fp = require("lodash/fp");
var _default = {
    id: 'cashrewards-12-percent',
    rewards: [
        {
            id: '12-percent-cashback',
            isEligible: function() {
                var productId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).productId;
                return !(0, _fp.isUndefined)(productId);
            }
        }
    ]
};
